import React from 'react'
import { useStateValue } from '../StateProvider';
import useGoogleSearch from '../useGoogleSearch';
import "./SearchPage.css"
import Response from "../response"
import { Link } from 'react-router-dom';
import Search from './Search';
import SearchIcon from "@material-ui/icons/Search"
import DescriptionIcon from "@material-ui/icons/Description"
import ImageIcon from "@material-ui/icons/Image"
import LocalOfferIcon from "@material-ui/icons/LocalOffer"
import RoomIcon from "@material-ui/icons/Room"
import MoreVertIcon from "@material-ui/icons/MoreVert"

function SearchPage() {
    const [{term='tesla'},dispatch] = useStateValue();
const {data} = useGoogleSearch(term);
if(!data){
    const data = Response;
}
//
    return (
    
        <div className="searchpage">
            <div className="searchpage__header">
                <Link to="/">
<img src="https://www.google.com/images/branding/googlelogo/2x/googlelogo_color_272x92dp.png" alt="" className="searchpage__logo" />
</Link>
<div className="searchpage__body">
    <Search hideButtons />
    <div className="searchpage__options">
        <div className="searchpage__optionleft">
<div className="searchpage__option">
<SearchIcon />
<Link to="/all">All</Link>
</div>
<div className="searchpage__option">
<DescriptionIcon />
<Link to="/news">News</Link>
</div>
<div className="searchpage__option">
<ImageIcon />
<Link to="/images">Images</Link>
</div>
<div className="searchpage__option">
<LocalOfferIcon />
<Link to="/shopping">Shopping</Link>
</div>
<div className="searchpage__option">
<RoomIcon />
<Link to="/maps">Maps</Link>
</div>
<div className="searchpage__option">
<MoreVertIcon />
<Link to="/more">More</Link>
</div>
        </div>
     <div className="searchpage__optionright">
         <div className="searchpage__option">
<Link to="/settings">Settings</Link>
         </div>
         <div className="searchpage__option">
<Link to="/tools">Tools</Link>
         </div>
     </div>
    </div>
</div>
            </div>
            {term &&(
                     <div className="searchpage__results">
             <p className="searchpage__resultcount">
                 About {data?.searchInformation.formattedTotalResults} results ({data?.searchInformation.formattedSearchTime} seconds) for {term}
             </p>{
                 data?.items.map(item=>(
                     <div className="searchpage__result">
                         <a href={item.link} className="">
                             {item.pagemap?.cse_image?.length>0 &&
                             item.pagemap?.cse_image[0]?.src &&  (
                                 <img src={item.pagemap?.cse_image[0]?.src} alt="" className="searchpage__resultimg" />
                             )
                             }
                         {

                             
                             item.displayLink 
                         }
                         </a>
                         <a href={item.link} className="searchpage__resulttitle">
                             <h3>{item.title}</h3>
                         </a>
                         <p className="searchpage__resultsnippet">
                             {item.snippet}
                         </p>
                     </div>
                 ))
             }
                     </div>
            )}

        </div>
    )
}

export default SearchPage
